module.exports = __webpack_public_path__ + "static/integration/img/ally-icon-white.5e94c18024419d8f6c3bb718ed9bd08f.png";